import {
  USER_UPDATED_DOWN_PAYMENT,
  USER_UPDATED_TRADE_IN_VALUE,
  USER_CLOSED_USER_AMOUNTS_PANEL,
  USER_OPENED_USER_AMOUNTS_PANEL,
  TOTAL_PERSONALIZED_AMOUNT_UPDATED,
  APP_UPDATED_DOWN_PAYMENT,
  SYSTEM_UPDATED_CASHBACK_AMOUNT
} from '../constants';

/**
 * When a user updates on of the Personalized payment inputs the app will
 * calculate the total personalized amount
 * @returns {function(*)}
 */

export function updateDownPaymentAction(downPayment, suppressTagging = false) {
  return (dispatch) => {
    dispatch({
      type: USER_UPDATED_DOWN_PAYMENT,
      downPayment,
      suppressTagging
    });
  };
}
export function updateDownPaymentActionApp(downPayment) {
  return (dispatch) => {
    dispatch({
      type: APP_UPDATED_DOWN_PAYMENT,
      downPayment
    });
  };
}

export function updateTradeInAction(tradeIn, suppressTagging = false) {
  return (dispatch) => {
    dispatch({
      type: USER_UPDATED_TRADE_IN_VALUE,
      tradeIn,
      suppressTagging
    });
  };
}

export function userAmountsClosedAction() {
  return (dispatch) => {
    dispatch({
      type: USER_CLOSED_USER_AMOUNTS_PANEL
    });
  }
}

export function userAmountsOpenedAction() {
  return (dispatch) => {
    dispatch({
      type: USER_OPENED_USER_AMOUNTS_PANEL
    });
  }
}

export function updateTotalPersonalisedAmount(totalPersonalizedAmount) {
  return (dispatch) => {
    dispatch({
      type: TOTAL_PERSONALIZED_AMOUNT_UPDATED,
      totalPersonalizedAmount
    });
  }
}

export function updateCashbackAmount(cashBackAmount) {
  return (dispatch) => {
    dispatch({
      type: SYSTEM_UPDATED_CASHBACK_AMOUNT,
      cashBackAmount
    });
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/actions/userAmounts.js
 **/